import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { getTask } from "../../../../services/usersService";
import Notes from "../../common/notes";
import Attachments from "../../common/attachments";
import TaskContent from "./taskContent";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function TaskDetail({ taskID = 0, journeyID = 0, onCloseDialog }) {
  const { reload } = useGlobalData();
  const [task, setTask] = useState({
    ID: 0,
    title: "",
    description: "",
    deadlineDate: DateTime.now().endOf("day"),
    statusID: 0,
    taskStatus: { title: "" },
  });
  useEffect(() => {
    if (taskID > 0) {
      getTaskData(taskID);
    }
  }, [taskID, reload]);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="Tasks" rightIcon="fas fa-tasks">
              <TaskContent
                journeyID={journeyID}
                taskImp={task}
                onCloseDialog={onCloseDialog}
              />
            </TabPanel>
            <TabPanel header="Attachments" rightIcon="fas fa-paperclip">
              <Attachments docType="TASK" docID={task.ID} />
            </TabPanel>
            <TabPanel header="Notes" rightIcon="fas fa-sticky-note">
              <Notes docType="TASK" docID={task.ID} />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </React.Fragment>
  );

  async function getTaskData(taskID) {
    const response = await getTask(taskID);
    const { data } = response.data;
    setTask(data.task);
  }
}

export default TaskDetail;
